import { TENANTCREATE_URL, TENANTDELETE_URL, TENANTLIST_URL, TENANTUPDATE_URL } from '../../config/config'
import { APICall } from '../APIRequest'

export const getTenantList = async () => {

  const parameter = {
  };

  const res = await APICall(TENANTLIST_URL,parameter)

  return converData(res)

};

export const createTenantData = async (row) => {
  const parameter = {
    "tenant_name": row.name,
    "tenant_name_en": row.tenant
  }

  const res = await APICall(TENANTCREATE_URL,parameter)
  if(!res.ok){
    console.log("Tenant Create Error",res);
  }
  console.log(res);

  return;
}

export const updateTenantData = async (row) => {
  let parameter = {
    "tenant_id": row.id,
    "tenant_info": row.info,
  }

  row.updateColume.forEach((item) => {
    if(item == "tenant"){
      parameter["tenant_name_en"] = row.tenant;
    }
    if(item == "name"){
      parameter["tenant_name"] = row.name;
    }
  });

  const res = await APICall(TENANTUPDATE_URL,parameter)
  if(!res.ok){
    console.log("Tenant Update Error",res);
  }

  return;

}

export const deleteTenantData = async (row) => {
  let parameter = {
    "tenant_id": row.id,
    "tenant_info": row.info,
  }
  const res = await APICall(TENANTDELETE_URL,parameter)
  if(!res.ok){
    console.log("Tenant Delete Error",res);
  }
  console.log(res);

  return;


}


const converData = (data) => {

  return data["tenant_info"].map((item) => {
    return {
      id: item["tenant_id"],
      info: item["tenant_info"],
      name: item["tenant_name"],
      tenant: item["tenant_name_en"],
      entrytime: item["created_at"],
    }
  })
}